import {GESTION_OPERATIVA_CHANGED_CLIENT} from "../constants"

export function reducer(state, action) {
    if(action.type===GESTION_OPERATIVA_CHANGED_CLIENT){
        return {
            ...state,
            cliente: action.data.client,
            client_id: action.data.client.id,
            sale: {
                ...state.sale,
                client_id: action.data.client.id,
                client_first_name: action.data.client.firstname,
                client_last_name: action.data.client.lastname,
                client_doc: action.data.client.document,
                client_doc_type: action.data.client.doctype,
                client_email: action.data.client.email,
                client_telefono: action.data.client.phone,
                cliente: action.data.client,
            },
            isModified: true
          }
    }else{
        return state
    }
  }